import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";

const CreateReceive = () => {
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultDateValue = new Date(date).toISOString().split("T")[0];

  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    date: defaultDateValue,
  });
  const [factory, setFactory] = useState([]);
  const [product, setProduct] = useState([]);
  const [products, setProducts] = useState([]);
  const [error, setError] = useState({});
  const [selectedFile, setSelectedFile] = useState({});
  const [isSelected, setIsSelected] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [vendor, setVendor] = useState({});
  const [vendorsList, setVendorsList] = useState([]);
  const [list, setList] = useState([
    { product_id: "", unit_id: "", qty: "", desc: "" },
  ]);
  const [loading, setLoading] = useState(false);
  const [discount, setDiscount] = useState(0);
  const [otherExpenses, setOtherExpenses] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [totalPayableAmount, setTotalPayableAmount] = useState(0);
  const [selectedFactory, setSelectedFactory] = useState(null); // Add this line

  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      try {
        const res = await Http.get("/vendor");
        setVendor(res.data);

        const options = res.data.map((vendor) => ({
          value: vendor.id,
          label: vendor.name,
        }));
        setVendorsList(options);

        const res2 = await Http.get("/factorySelect2");
        setFactory(res2.data);

        // Set first factory as default if available
        if (res2.data && res2.data.length > 0) {
          const firstFactory = res2.data[0];
          setSelectedFactory(firstFactory);
          setInputs((values) => ({ ...values, ["factory_id"]: firstFactory.value }));
        }

        const res3 = await Http.get("/product");
        setProducts(res3.data);
        const productOptions = res3.data.map((product) => ({
          value: product.id,
          label: product.name,
        }));
        setProduct(productOptions);

        const res4 = await Http.get(
          "/last-code-increment-by-one/grns/receipt_no"
        );
        setInputs((values) => ({ ...values, ["receipt_no"]: res4.data }));
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const totalSubtotal = list.reduce((total, item) => {
    const totalSubtotal =
      (parseFloat(item.qty) || 0) * (parseFloat(item.price) || 0);
    const finalPrice =
      totalSubtotal +
      (parseFloat(item.damage_qty) || 0) * (parseFloat(item.deduction) || 0);
    return total + finalPrice;
  }, 0);

  useEffect(() => {
    // const calculatedDiscountAmount = (totalSubtotal * discountPercentage) / 100;
    const calculatedDiscountAmount = discount;
    setDiscountAmount(calculatedDiscountAmount.toFixed(2));

    const calculatedTotalPayable = totalSubtotal - calculatedDiscountAmount + otherExpenses;
    setTotalPayableAmount(calculatedTotalPayable.toFixed(2));
  }, [totalSubtotal, discount, otherExpenses]);

  const handleDiscountChange = (e) => {
    const discount = parseFloat(e.target.value) || 0;
    setDiscount(discount);
  };
  const handleOtherExpensesChange = (e) => {
    const otherExpenses = parseFloat(e.target.value) || 0;
    setOtherExpenses(otherExpenses);
  };
  const selectHandleChangeAddMore = (selectedOption, actionMeta, index) => {
    const name = actionMeta.name;
    const value = selectedOption ? selectedOption.value : null;
    const inputInfo = [...list]; // Defined Experience State All Information into List Variable

    inputInfo[index][name] = value;

    if (name === "product_id") {
      if (selectedOption) {
        const selectedProduct = products.find(
          (product) => product.id === selectedOption.value
        );
        if (selectedProduct && selectedProduct.price) {
          inputInfo[index]["price"] = selectedProduct.price;
        }
      } else {
        inputInfo[index]["price"] = ""; // Clear price if product is unselected
      }
    }

    setList(inputInfo);
  };
  const selectHandleChange = (selectedOption, actionMeta) => {
    const name = actionMeta.name;
    const value = selectedOption ? selectedOption.value : null;

    // Update inputs state
    setInputs((values) => ({ ...values, [name]: value }));

    // Update selectedVendor state for vendor selection
    if (name === "vendor_id") {
      setSelectedVendor(selectedOption);
    }

    // Update selectedFactory state for factory selection
    if (name === "factory_id") {
      setSelectedFactory(selectedOption);
    }
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  const handleFileChange = (e) => {
    const fileArray = [];
    const files = e.target.files;
    Object.keys(files).forEach((key) => {
      fileArray.push(e.target.files[key]);
    });
    setSelectedFile(fileArray);
    setIsSelected(true);
  };

  // Set Experience State
  const handleInputChange = (e, index) => {
    const { name, value } = e.target; // Chanages Experience Input Name and Value
    const inputInfo = [...list]; // Defined Experience State All Information into List Variable

    inputInfo[index][name] = value;
    setList(inputInfo);
  };
  // Add More List
  const addMoreList = () => {
    setList([
      ...list,
      { product_id: "", unit_id: "", qty: "", price: "", desc: "" },
    ]); // Add One More List
  };
  // Remove List
  const removeList = (index) => {
    const inputInfo = [...list]; // Load All Existing experience State Data
    inputInfo.splice(index, 1); // Remove Experience by Index/Click Event Wise
    setList(inputInfo); // Replace Existing experience into State
  };

  const formSubmit = () => {
    const listArr = [];
    Object.keys(list).forEach((key) => {
      listArr.push(list[key]);
    });

    // inputs.file = selectedFile;
    inputs.items = listArr;
    inputs.discount = discount;
    inputs.other_expenses = otherExpenses;
    console.log(inputs, "inputs");
    Http.post("/others-receive", inputs)
      .then((res) => {
        navigate("/others-receive", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };

  const handleVendorChange = (selected) => {
    setSelectedVendor(selected);
  };

  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Purchase</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Purchase</h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>
                      Date <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={inputs.date || ""}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-lg">
                    <label>
                      Receipt no <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="receipt_no"
                      value={inputs.receipt_no || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label htmlFor="">
                      Factory <i className="fa fa-star required"></i>
                    </label>

                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      name="factory_id"
                      options={factory}
                      value={selectedFactory}
                      onChange={selectHandleChange}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg" style={{ zIndex: 999 }}>
                    <div className="form-group">
                      <label>
                        Select Vendor <i className="fa fa-star required"></i>
                      </label>
                      <Select
                        options={vendorsList}
                        value={selectedVendor}
                        onChange={selectHandleChange}
                        name="vendor_id"
                        placeholder="Select Vendor"
                        isClearable
                      />
                    </div>
                  </div>
                  <div className="col-lg">
                    <label>Bill No</label>
                    <input
                      type="text"
                      className="form-control"
                      name="bill_no"
                      value={inputs.bill_no || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg">
                    <label>Description</label>
                    <textarea
                      className="form-control"
                      name="description"
                      value={inputs.description || ""}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-10"></div>
                  <div className="col-2">
                    <button
                      className="btn btn-info btn-block mg-b-10"
                      onClick={addMoreList}
                    >
                      <i className="fa fa-plus mg-r-10"></i> ADD More
                    </button>
                  </div>
                  <div className="col-12">
                    <table className="table table-sm align-items-center mb-0">
                      <thead>
                        <tr>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Product
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Qty
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Price <i className="fa fa-star required"></i>
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Subtotal
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Damage qty
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Deduction
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Subtotal
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Final Price
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Description
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.from(list).map((x, i) => {
                          const subtotal =
                            (parseFloat(x.qty) || 0) *
                            (parseFloat(x.price) || 0);
                          const deductionSubtotal =
                            (parseFloat(x.damage_qty) || 0) *
                            (parseFloat(x.deduction) || 0);
                          const finalPrice =
                            subtotal +
                            (parseFloat(x.damage_qty) || 0) *
                            (parseFloat(x.deduction) || 0);
                          return (
                            <tr key={i}>
                              <td className="col-2">
                                <Select
                                  options={product}
                                  value={
                                    product.find(
                                      (item) => item.value === x.product_id
                                    ) || null
                                  }
                                  onChange={(selectedOption, actionMeta) =>
                                    selectHandleChangeAddMore(
                                      selectedOption,
                                      actionMeta,
                                      i
                                    )
                                  }
                                  name="product_id"
                                  placeholder="Select Product"
                                  isClearable
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="qty"
                                  value={x.qty || ""}
                                  onChange={(e) => handleInputChange(e, i)}
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  // readOnly
                                  className="form-control"
                                  name="price"
                                  value={x.price || ""}
                                  onChange={(e) => handleInputChange(e, i)}
                                />
                              </td>
                              <td align="right">
                                <div className="form-control-plaintext font-weight-bold">
                                  {subtotal.toFixed(2)}
                                </div>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="damage_qty"
                                  value={x.damage_qty || ""}
                                  placeholder="Damage qty"
                                  onChange={(e) => handleInputChange(e, i)}
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="deduction"
                                  value={x.deduction || ""}
                                  placeholder="deduction"
                                  onChange={(e) => handleInputChange(e, i)}
                                />
                              </td>
                              <td align="right">
                                <div className="form-control-plaintext font-weight-bold">
                                  {deductionSubtotal.toFixed(2)}
                                </div>
                              </td>
                              <td align="right">
                                <div className="form-control-plaintext font-weight-bold text-success">
                                  {finalPrice.toFixed(2)}
                                </div>
                              </td>
                              <td>
                                <textarea
                                  className="form-control"
                                  name="desc"
                                  value={x.desc || ""}
                                  onChange={(e) => handleInputChange(e, i)}
                                ></textarea>
                              </td>
                              <td>
                                {list.length > 1 ? (
                                  <button
                                    className="btn btn-danger btn-sm btn-block"
                                    onClick={() => removeList(i)}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot>
                        <tr className="table-active">
                          <td
                            colSpan="3"
                            className="text-right font-weight-bold"
                          >
                            Total Price:
                          </td>
                          <td className="font-weight-bold " align="right">
                            {list
                              .reduce((total, item) => {
                                const subtotal =
                                  (parseFloat(item.qty) || 0) *
                                  (parseFloat(item.price) || 0);
                                return total + subtotal;
                              }, 0)
                              .toFixed(2)}
                          </td>
                          <td colSpan="2"></td>
                          <td className="font-weight-bold" align="right">
                            {list
                              .reduce((total, item) => {
                                const subtotal =
                                  (parseFloat(item.damage_qty) || 0) *
                                  (parseFloat(item.deduction) || 0);
                                return total + subtotal;
                              }, 0)
                              .toFixed(2)}
                          </td>
                          {/* Final Total */}
                          <td
                            align="right"
                            className="font-weight-bold text-success"
                          >
                            {list
                              .reduce((total, item) => {
                                const subtotal =
                                  (parseFloat(item.qty) || 0) *
                                  (parseFloat(item.price) || 0);
                                const finalPrice =
                                  subtotal +
                                  (parseFloat(item.damage_qty) || 0) *
                                  (parseFloat(item.deduction) || 0);
                                return total + finalPrice;
                              }, 0)
                              .toFixed(2)}
                          </td>
                          <td colSpan="2"></td>
                        </tr>
                        <tr className="table-active">
                          <td
                            colSpan="5"
                            className="text-right font-weight-bold text-danger"
                          >
                            Discount Amount:
                          </td>
                          <td
                            colSpan="2"
                            className="font-weight-bold"
                            align="center"
                          >
                            <input
                              type="number"
                              className="form-control"
                              value={discount}
                              onChange={handleDiscountChange}
                              placeholder="Enter discount amount"
                            />
                          </td>
                          <td
                            className="font-weight-bold text-danger"
                            align="right"
                          >
                            {discountAmount}
                          </td>
                          <td colSpan="2"></td>
                        </tr>
                        <tr className="table-active">
                          <td
                            colSpan="5"
                            className="text-right font-weight-bold text-danger"
                          >
                            Other Expenses:
                          </td>
                          <td
                            colSpan="2"
                            className="font-weight-bold"
                            align="center"
                          >
                            <input
                              type="number"
                              className="form-control"
                              value={otherExpenses}
                              onChange={handleOtherExpensesChange}
                              placeholder="Enter other expenses"
                            />
                          </td>
                          <td
                            className="font-weight-bold text-danger"
                            align="right"
                          >
                            {otherExpenses.toFixed(2)}
                          </td>
                          <td colSpan="2"></td>
                        </tr>
                        <tr className="table-active">
                          <td
                            colSpan="7"
                            className="text-right font-weight-bold"
                          >
                            Total payable Amount:
                          </td>
                          <td className="font-weight-bold" align="right">
                            {totalPayableAmount}
                          </td>
                          <td colSpan="2"></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-6"></div>
                  <div className="col-3"></div>
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Create
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default CreateReceive;